import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { withJwt } from '../../utils/with-jwt';
import { accountsEnvironment } from './accounts-environment';
import { companySettingsSchema } from './schemas/company-settings.schema';

export function getCompanySettings() {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.companySettingsUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: companySettingsSchema,
      })
    )
  );
}
